module.exports = __webpack_public_path__ + "img/GAME_QUIZNORI1.4f52d929.jpg";